export default __webpack_public_path__ + "static/card-visa-classic-d8a0bd2774a533de16db306cb55c09d7.png";